// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__OvEHd","check":"Checkbox_check__70lOh","active":"Checkbox_active__x5ekm"};